module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAgCAYAAABgrToAAAAAAXNSR0IArs4c6QAAATNJREFUWEft1bFuwjAQBuA7d+Y1eAjYOzNDVanDKQ/RbAgWnsCXoaJSl2zd+iY8R17AVxkBQkAUxc6dMuDd8eff9h+EkQ8cuQ+ewNwTUk2QmVcA8EpEH4gYUrBqwKqq3kIIewBwiPhDRO8pSDWg936JiN8i8hKTS0WqASNqCKQqcAikOjAXaQLMQZoBU5GmwBTkHbCu62MtaI6maVYhhK/YkV0VdAf03osmru3bbT05GmCEO+cWRPR7vYlHwINRgtPzEZ/WK4ui2Nyubf5IIoCZ1yJSXmEe4o730yityzJ9cObAvjhTYArODJiKMwHm4NSBuThVIDOXIrI+P1/n3CcRbfu2hlrNMPMMAP5EZAIArT3XBVYDngp5hohzItp1QVr/0akTreapJjjEJp7A3BRHn+A/hHq1IeqZheMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default_go.png
// module id = e1u+
// module chunks = 1